export default defineNuxtPlugin((nuxtApp) => {
  // disable ads on localhost and cloudflare preview branch deploy
  if (import.meta.env.DEV || window.location.hostname.endsWith("pages.dev")) {
    return;
  }

  (function (w, d) {
    w.adthrive = w.adthrive || {};
    w.adthrive.cmd = w.adthrive.cmd || [];
    w.adthrive.plugin = "adthrive-ads-manual-spa";
    w.adthrive.host = "ads.adthrive.com";
    var s = d.createElement("script");
    s.async = true;
    s.referrerpolicy = "no-referrer-when-downgrade";
    s.src =
      "https://" +
      w.adthrive.host +
      `/sites/64f8b60778b84a08902d456d/ads.min.js?referrer=` +
      w.encodeURIComponent(w.location.href);
    var n = d.getElementsByTagName("script")[0];
    n?.parentNode.insertBefore(s, n);
  })(window, document);
  !(function () {
    "use strict";
    !(function (e) {
      if (-1 === e.cookie.indexOf("__adblocker")) {
        e.cookie = "__adblocker=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        var t = new XMLHttpRequest();
        t.open("GET", "https://www.npttech.com/advertising.js", !0),
          (t.onreadystatechange = function () {
            if (XMLHttpRequest.DONE === t.readyState)
              if (200 === t.status) {
                var n = e.createElement("script");
                (n.innerHTML = t.responseText), e.getElementsByTagName("head")[0].appendChild(n);
              } else {
                var a = new Date();
                a.setTime(a.getTime() + 3e5), (e.cookie = "__adblocker=true; expires=" + a.toUTCString() + "; path=/");
              }
          }),
          t.send();
      }
    })(document);
  })();

  !(function () {
    "use strict";
    var e;
    (e = document),
      (function () {
        var t, n;
        function r() {
          var t = e.createElement("script");
          (t.src = "https://cafemedia-com.videoplayerhub.com/galleryplayer.js"), e.head.appendChild(t);
        }
        function a() {
          var t = e.cookie.match("(^|[^;]+)\\s*__adblocker\\s*=\\s*([^;]+)");
          return t && t.pop();
        }
        function c() {
          clearInterval(n);
        }
        return {
          init: function () {
            var e;
            "true" === (t = a())
              ? r()
              : ((e = 0),
                (n = setInterval(function () {
                  (100 !== e && "false" !== t) || c(), "true" === t && (r(), c()), (t = a()), e++;
                }, 50)));
          },
        };
      })().init();
  })();
});
